<template>
  <block style="padding-bottom: 60px;">
    <template slot="header"
      >Eliminar atención</template
    >
    <div class="body">
      <div class="student-attention">
        <h3>¿Deseas eliminar la atención definitivamente?</h3>
      </div>
    </div>

    <div class="actions">
      <button class="button is-danger delete" :class="{ 'is-loading': loading }" @click="submit">
        Eliminar
      </button>
      &nbsp;
      <button
        class="button is-primary is-outlined cancel"
        :disabled="loading"
        @click="navigateTo('app.profile.attentions')"
      >
        Cancelar
      </button>
    </div>
  </block>
</template>

<script>
import gql from "graphql-tag"
import Block from "@/components/_base/Block.vue"
import STUDENT_ATTENTIONS from "../attentions/graphql/StudentAttentions.gql"
import OverlayedMixin from "@/mixins/OverlayedMixin"
import DerivationList from "@/components/_base/DerivationList.vue"

export default {
  name: "ProfileDeleteAttention",
  mixins: [OverlayedMixin],
  props: {
    studentId: { type: String },
    attentionId: { type: String }
  },
  data() {
    return { loading: false }
  },
  methods: {
    navigateTo(route) {
      this.$emit("hello", route)
    },
    submit() {
      console.log("Delete Attention...")
      this.loading = true

      this.$apollo
        .mutate({
          mutation: gql`
            mutation DeleteAttention($input: DeleteAttentionInput!) {
              deleteAttention(input: $input) {
                id
              }
            }
          `,
          variables: {
            input: {
              attentionId: this.attentionId
            }
          },
          refetchQueries: [
            {
              query: STUDENT_ATTENTIONS,
              variables: { studentId: this.studentId }
            }
          ],
          optimisticResponse: {
            __typename: "Mutation",
            finishAttention: {
              __typename: "Attention",
              id: -1
            }
          }
        })
        .then(data => {
          this.loading = false
          this.navigateTo("app.profile.attentions")
        })
        .catch(error => {
          this.loading = false
          console.error(error)
        })
    }
  },
  components: {
    Block,
    DerivationList
  }
}
</script>

<style scoped>
.student-attention {
  margin-bottom: 35px;
}

.actions .button.delete {
  padding: 0 45px;
}

.actions .button.cancel {
  padding: 0 20px;
}
</style>
